import FormFields from "../../common/FormFields";
import useForm from "../../../hooks/common/useForm";
import { Alert, Button } from "antd";
import { useState } from "react";
import { API_CHANGE_PASSWORD } from "../../../utils/apis";
import axios from "axios";
import { BASE_API_URL } from "../../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { changePasswordFields } from "../../../utils/change_password";
import toast from "react-hot-toast";

const ChangePassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { updateFormValue, form, onChange } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const userTokenData = location?.state?.data;

  const onSubmit = (e: any) => {
    const { token } = userTokenData;
    e.preventDefault();
    setLoading(true);
    const API = `${BASE_API_URL}${API_CHANGE_PASSWORD}`;
    axios
      .post(
        API,
        { ...form },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(({ data }) => {
        toast.success(data.message || "Password changed successfully");
        setLoading(false);
        setError(null);
        navigate("/login");
      })
      .catch((error) => {
        setLoading(false);
        const message =
          error.response?.data?.password?.[0] ||
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred.";
        setError(message);
      });
  };

  return (
    <form onSubmit={onSubmit}>
      <AuthLayout
        title="Change your password"
        subtitle="You are currently using the default password. Please change it to continue."
        footer={
          <Link to="/login" className="primaryColor">
            Back to sign in
          </Link>
        }
      >
        {error ? (
          <Alert className="font12" showIcon type="error" message={error} />
        ) : null}

        <FormFields
          fields={changePasswordFields}
          updateFormValue={updateFormValue}
          form={form}
          onChange={onChange}
          error={{}}
        />

        <Button type="primary" htmlType="submit" loading={loading}>
          Confirm Password
        </Button>
      </AuthLayout>
    </form>
  );
};

export default ChangePassword;
